var exports = {
  "cV": "ControlGroupContainer__sfSyev",
  "Ij": "fullWidth__fUkPZX",
  "YQ": "spacious__tVrT9V",
  "PQ": "border__cQ6jhQ",
};

module.exports = exports;
